import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SubscriptionSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, loading } = useAuth();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Wait for auth to load before making decisions
    if (loading) return;

    if (!user) {
      navigate('/login');
      return;
    }

    // Optional: Verify the session with your backend
    // This could call your backend to confirm the subscription was successful
  }, [user, loading, navigate, sessionId]);

  // Show loading state while auth is being determined
  if (loading) {
    return (
      <div className='min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center px-4'>
        <div className='text-center'>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4'></div>
          <p className='text-gray-600'>Verifying your subscription...</p>
        </div>
      </div>
    );
  }

  return (
    <div className='min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center px-4'>
      <div className='max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center'>
        {/* Success Icon */}
        <div className='w-16 h-16 mx-auto mb-6 bg-green-100 rounded-full flex items-center justify-center'>
          <svg
            className='w-8 h-8 text-green-600'
            fill='currentColor'
            viewBox='0 0 20 20'
          >
            <path
              fillRule='evenodd'
              d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
              clipRule='evenodd'
            />
          </svg>
        </div>

        {/* Success Message */}
        <h1 className='text-2xl font-bold text-gray-900 mb-2'>
          Subscription Successful!
        </h1>
        <p className='text-gray-600 mb-8'>
          Welcome to your new plan! Your subscription has been activated and you
          can now start practicing with your new minutes allowance.
        </p>

        {/* Action Buttons */}
        <div className='space-y-3'>
          <button
            onClick={() => navigate('/practice')}
            className='w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-blue-700 transition-colors'
          >
            Start Practicing
          </button>
          <button
            onClick={() => navigate('/profile')}
            className='w-full border border-gray-300 text-gray-700 py-3 px-6 rounded-lg font-medium hover:bg-gray-50 transition-colors'
          >
            View Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccessPage;
